import React from 'react';
import { CtaButton } from '../ui/CtaButton';
import { resultCopy } from '../../data/codes';
import { WHATSAPP_URL } from '../../data/site';
import type { CodeResult } from '../../types/quiz';
interface QuizResultProps {
  result: CodeResult;
  nombre?: string;
  onRestart: () => void;
}
export function QuizResult({
  result,
  nombre,
  onRestart
}: QuizResultProps) {
  const copy = resultCopy[result.key];
  return <div className="text-center" data-id="element-251" data-mp="1sw9ub5l989ur">
      <p className="text-[10px] font-semibold uppercase tracking-[0.26em] text-gold-dark" data-id="element-252" data-mp="1sviccxkkyamy">
        {nombre ? `${nombre}, tu código actual es` : 'Tu código actual es'}
      </p>

      <p className="mt-3 font-serif text-5xl font-light leading-none text-gold" data-id="element-253" data-mp="22ltfwj0cqhtb">
        {result.number}
      </p>

      <h3 className="mt-4 font-serif text-[1.75rem] font-light leading-tight text-ink sm:text-4xl" data-id="element-254" data-mp="1xotj6ype6rev">
        {result.name}
      </h3>

      <div className="rule-gold my-8" aria-hidden="true" data-id="element-255" data-mp="27m7qo8tc85v1">
        <span className="text-xs text-gold" data-id="element-256" data-mp="27nsk1v3x1irb">✦</span>
      </div>

      <div className="mx-auto max-w-xl space-y-4 text-left" data-id="element-257" data-mp="ik1hgt29dpnl">
        {copy.paragraphs.map(p => <p key={p} className="text-[17px] leading-relaxed text-ink-soft" data-id="element-258" data-mp="mk39sbm3t6q7">
            {p}
          </p>)}
      </div>

      <figure className="mx-auto mt-9 max-w-xl rounded-2xl border border-gold/35 bg-cream px-6 py-7 sm:px-9" data-id="element-259" data-mp="rid5cnbqq9cc">
        <blockquote className="font-serif text-xl font-light italic leading-snug text-ink sm:text-2xl" data-id="element-260" data-mp="wkc9hzfb1aac">
          {result.question}
        </blockquote>
      </figure>

      <div className="mt-9 flex flex-col items-center gap-4" data-id="element-261" data-mp="15inwzskvjryk">
        <CtaButton href={WHATSAPP_URL} size="lg" pixelEvent="Lead" pixelParams={{
        content_name: 'Resultado del test — Profundizar',
        code: result.name
      }} data-id="element-262" data-mp="1aafs8gez6lv1">
          Quiero profundizar en mi resultado
        </CtaButton>

        <button type="button" onClick={onRestart} className="text-[12px] uppercase tracking-[0.16em] text-ink-muted underline decoration-gold/40 underline-offset-4 transition-colors duration-200 hover:text-ink" data-id="element-263" data-mp="1p7ggub1ve0pa">
          Volver a hacer el test
        </button>
      </div>
    </div>;
}